import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy loading de componentes del observatorio - usando named exports correctamente
const Observatorio = lazy(() => import('@feature/observatorio').then(m => ({ default: m.Observatorio })));
const CondicionesMeteorologicas = lazy(() => import('@feature/observatorio').then(m => ({ default: m.CondicionesMeteorologicas })));
const EventosTormenta = lazy(() => import('@feature/observatorio').then(m => ({ default: m.EventosTormenta })));
const MonitoreoAmbientalPage = lazy(() => import('@feature/observatorio').then(m => ({ default: m.MonitoreoAmbientalPage })));
const MonitoreoVolcanicoPage = lazy(() => import('@feature/observatorio').then(m => ({ default: m.MonitoreoVolcanicoPage })));
const MapaInteractivoPage = lazy(() => import('@feature/observatorio').then(m => ({ default: m.MapaInteractivoPage })));

import { ROUTES } from '@shared/constants/routes.constants';

/**
 * Rutas del módulo del observatorio
 */
export const observatoryRoutes: RouteObject[] = [
  {
    path: ROUTES.OBSERVATORY.ROOT,
    element: <Observatorio />,
  },
  {
    path: ROUTES.OBSERVATORY.CONDICIONES_METEOROLOGICAS,
    element: <CondicionesMeteorologicas />,
  },
  {
    path: ROUTES.OBSERVATORY.EVENTOS_TORMENTA,
    element: <EventosTormenta />,
  },
  {
    path: ROUTES.OBSERVATORY.MONITOREO_AMBIENTAL,
    element: <MonitoreoAmbientalPage />,
  },
  {
    path: ROUTES.OBSERVATORY.MONITOREO_VOLCANICO,
    element: <MonitoreoVolcanicoPage />,
  },
  {
    path: ROUTES.OBSERVATORY.MAPA_INTERACTIVO,
    element: <MapaInteractivoPage />,
  },
];
